// Vendor libraries
import { EventEmitter, TemplateRef } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../directives/icon/icon.directive";
function SimpleModalHeaderComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.header);
} }
function SimpleModalHeaderComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "a", 8);
    i0.ɵɵlistener("click", function SimpleModalHeaderComponent_div_2_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.back.emit()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 9);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-back");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.header);
} }
function SimpleModalHeaderComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, " \u00A0(edited) ");
    i0.ɵɵelementEnd();
} }
function SimpleModalHeaderComponent_Conditional_5_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SimpleModalHeaderComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SimpleModalHeaderComponent_Conditional_5_ng_container_0_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelement(1, "div", 12);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.customHeaderFragment);
} }
function SimpleModalHeaderComponent_div_6_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 17);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r0.resetModalText);
} }
function SimpleModalHeaderComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14);
    i0.ɵɵlistener("click", function SimpleModalHeaderComponent_div_6_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.resetModalHandler.emit()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 15);
    i0.ɵɵtemplate(3, SimpleModalHeaderComponent_div_6_span_3_Template, 1, 1, "span", 16);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-reset");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.resetModalText);
} }
function SimpleModalHeaderComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 18);
    i0.ɵɵlistener("click", function SimpleModalHeaderComponent_div_7_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.closeModalHandler.emit()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 15);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-close");
} }
/**
 *
 * Simple Modal Header Component
 *
 * Input Properties:
 *
 *  header: The text to use for the header
 *  resetModalText: The text to use for the reset button
 *  showUnsavedStatus: Whether or not to show '(edited)' in the header
 *  selectedObject: A RadioButton (no label necessary) representing the selected value.
 *  extraCssClasses: optional CSS classes to assign to header
 *
 *
 * Output Properties:
 *
 *  closeModalHandler: EventEmitter that emits when the user hits the X button
 *  resetModalHandler: EventEmitter that emits when the user hits the reset button
 *
 */
export class SimpleModalHeaderComponent {
    constructor() {
        this.showBackButton = false;
        this.showCloseButton = true;
        this.closeModalHandler = new EventEmitter();
        this.resetModalHandler = new EventEmitter();
        this.back = new EventEmitter();
        this.customHeaderFragment = null;
        this.showCloseModalHandler = false;
        this.showResetModalHandler = false;
    }
    ngOnInit() {
        this.showCloseModalHandler = this.closeModalHandler.observers.length > 0;
        this.showResetModalHandler = this.resetModalHandler.observers.length > 0;
    }
}
SimpleModalHeaderComponent.ɵfac = function SimpleModalHeaderComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SimpleModalHeaderComponent)(); };
SimpleModalHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SimpleModalHeaderComponent, selectors: [["ycn-simple-modal-header"]], inputs: { header: "header", showBackButton: "showBackButton", showCloseButton: "showCloseButton", resetModalText: "resetModalText", showUnsavedStatus: "showUnsavedStatus", extraCssClasses: "extraCssClasses", customHeaderFragment: "customHeaderFragment" }, outputs: { closeModalHandler: "closeModalHandler", resetModalHandler: "resetModalHandler", back: "back" }, standalone: false, decls: 8, vars: 7, consts: [[1, "modal-header", "user-select-none", 3, "ngClass"], ["class", "modal-title", 3, "textContent", 4, "ngIf"], ["class", "modal-title", 4, "ngIf"], ["class", "modal-title text-blue", 4, "ngIf"], [1, "modal-header-actions"], ["class", "modal-header-action", 4, "ngIf"], [1, "modal-title", 3, "textContent"], [1, "modal-title"], ["href", "javascript:void(0);", 1, "d-flex", "align-items-center", 3, "click"], ["ycnIcon", "", 1, "mr-1", 3, "name"], [1, "modal-title", "text-blue"], [4, "ngTemplateOutlet"], [1, "divider-vertical", "ml-1"], [1, "modal-header-action"], ["aria-label", "Reset", 1, "btn", "btn-modal-header", 3, "click"], ["ycnIcon", "", 3, "name"], [3, "textContent", 4, "ngIf"], [3, "textContent"], ["data-test-id", "simple-modal-header-close", "aria-label", "Close", 1, "close", "btn", "btn-modal-header", 3, "click"]], template: function SimpleModalHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, SimpleModalHeaderComponent_div_1_Template, 1, 1, "div", 1)(2, SimpleModalHeaderComponent_div_2_Template, 5, 2, "div", 2)(3, SimpleModalHeaderComponent_span_3_Template, 2, 0, "span", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, SimpleModalHeaderComponent_Conditional_5_Template, 2, 1)(6, SimpleModalHeaderComponent_div_6_Template, 4, 2, "div", 5)(7, SimpleModalHeaderComponent_div_7_Template, 3, 1, "div", 5);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.extraCssClasses);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.showBackButton);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showBackButton);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showUnsavedStatus);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.customHeaderFragment ? 5 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showResetModalHandler);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showCloseButton);
    } }, dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i2.IconDirective], encapsulation: 2 });
